<span class="article-date nordic-blue-900-text text-icon-primary font-body-small">
  @if (text()) {
    {{ text() }}
  }
  {{ date() | finTimestamp }}
</span>
